// src/components/overlays/packs/Hearts.jsx
import { useMemo } from 'react';

/**
 * Floating hearts overlay (SVG-based, not emoji)
 * Intensity: 'low' | 'med' | 'high'
 */
export default function Hearts({ intensity = 'med' }: { intensity?: string }) {
  const count = useMemo(() => {
    if (intensity === 'high') return 60;
    if (intensity === 'low') return 18;
    return 32; // 'med'
  }, [intensity]);

  const hearts = useMemo(() => {
    return Array.from({ length: count }, (_, i) => {
      const left = Math.random() * 100;          // %
      const delay = Math.random() * 6;           // s
      const duration = 9 + Math.random() * 8;    // 9–17s
      const size = 14 + Math.random() * 16;      // px
      const drift = -40 + Math.random() * 80;    // px
      const spin = 360 + Math.random() * 360;    // deg
      const hue = 345 + Math.random() * 20;      // soft reds

      return {
        id: `heart-${i}-${Math.random().toString(36).slice(2)}`,
        left,
        delay,
        duration,
        size,
        drift,
        spin,
        color: `hsl(${hue}deg 70% 60%)`,
        opacity: 0.9,
      };
    });
  }, [count]);

  return (
    <div className="overlay-root" aria-hidden="true">
      <div className="overlay-layer">
        {hearts.map((h) => (
          <svg
            key={h.id}
            className="heart"
            viewBox="0 0 24 24"
            style={{
              position: 'absolute',
              top: '-8vh',
              left: `${h.left}%`,
              width: `${h.size}px`,
              height: `${h.size}px`,
              fill: h.color,
              opacity: h.opacity,
              // animation combo set in CSS; we pass custom props via CSS variables:
              animationDelay: `${h.delay}s`,
              animationDuration: `${h.duration}s`,
              // custom per-node vars
              ['--drift' as string]: `${h.drift}px`,
              ['--spin' as string]: `${h.spin}deg`,
            }}
          >
            {/* simple heart path */}
            <path d="M12 21s-6.716-4.162-9.428-7.21C.678 11.689.5 9.323 2.02 7.8a4.54 4.54 0 0 1 6.42 0L12 9.36l3.56-1.56a4.54 4.54 0 0 1 6.42 0c1.52 1.524 1.342 3.89-.552 5.99C18.716 16.838 12 21 12 21z" />
          </svg>
        ))}
      </div>
    </div>
  );
}
